/**
 * @desc Gets the addon names for display
 * @param {Object} supplements
 * @return {String}
 */
function getAddOnNames(supplements) {
  const names = [];

  supplements.forEach(supplement => {
    names.push(supplement.name);
  });
  const sortedNames = names.sort().join(', ');

  return sortedNames;
}

export default getAddOnNames;
